export const DECISION_SELF = 'self';
export const DECISION_GUEST = 'guest';
